import request from '@/utils/request'

let MusicApi = {
  /*列表*/
  MusicList(data, errorback) {
    return request._get('/shop/music.Music/index', data, errorback);
  },
  /*列表详情*/
  MusicDetail(data, errorback) {
    return request._get('/shop/music.Music/detail', data, errorback);
  },
  /*添加*/
  MusicAdd(data, errorback) {
    return request._post('/shop/music.Music/Add', data, errorback);
  },
  /*修改*/
  updateMusic(data, errorback) {
    return request._post('/shop/music.Music/edit', data, errorback);
  },
  /*删除*/
  Musicdelete(data, errorback) {
    return request._post('/shop/music.Music/delete', data, errorback);
  },
  /*是否显示音乐*/
  Musicshow(data, errorback) {
    return request._post('/shop/music.Music/show', data, errorback);
  },
  // ==========================================================================
  /*通话记录列表*/
  calllist(data, errorback) {
    return request._post('/shop/plus.Dyplsapi/lists', data, errorback);
  },
  getcallUrl(data, errorback) {
    return request._get('/shop/plus.Dyplsapi/getRecordUrl', data, errorback);
  },

}

export default MusicApi;



// WEBPACK FOOTER //
// ./src/api/music.js